import React, { PureComponent } from 'react'

import PropTypes from 'prop-types'
import classNames from 'classnames'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import { withStyles } from '@material-ui/core/styles'

import * as toastModule from 'modules/toast'

const styles = () => ({
  root: {
    position: 'fixed',
    top: 0,
    left: 0,
    right: 0,
    height: 0,
    zIndex: 999999,
    overflow: 'hidden',
    transition: 'all .3s ease',
  },
  open: {
    height: 64,
  },
})

class ToastContainer extends PureComponent {
  static displayName = 'ToastContainer'

  static propTypes = {
    data: PropTypes.any,
    actions: PropTypes.object,
    open: PropTypes.bool.isRequired,
    componentName: PropTypes.string,
    classes: PropTypes.object.isRequired,
  }

  static defaultProps = {
    data: {},
    componentName: undefined,
  }

  getContentComponent = (toast) => {
    if (toastModule[toast]) {
      return toastModule[toast][1]
    }
    return null
  }

  handleOnClose = () => {
    this.props.actions.hideToast()
  }

  componentDidUpdate() {
    const { open, data, actions } = this.props

    if (open && !data.manual) {
      if (this.closeTimeout) {
        clearTimeout(this.closeTimeout)
      }

      this.closeTimeout = setTimeout(() => {
        actions.hideToast()
      }, data.timeout || 3200)
    }
  }

  render() {
    const {
      classes, data, open, componentName 
    } = this.props

    const ContentComponent = this.getContentComponent(componentName)

    return (
      <div className={classNames(classes.root, open && classes.open)}>
        {ContentComponent && (
          <ContentComponent
            open={open}
            data={data}
            handleClose={this.handleOnClose}
          />
        )}
      </div>
    )
  }
}

function mapStateToProps(state) {
  return {
    open: state.toast.open,
    data: state.toast.data,
    componentName: state.toast.componentName,
  }
}

function mapDispatchToProps(dispatch) {
  const actions = Object.assign({}, toastModule)
  return {
    actions: bindActionCreators(actions, dispatch),
  }
}

const ToastComponent = withStyles(styles)(ToastContainer)
export default connect(mapStateToProps, mapDispatchToProps)(ToastComponent)



// WEBPACK FOOTER //
// ./src/containers/ToastContainer.js